export default "__VITE_ASSET__86a7652b__"